import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { MenuItem } from '@core/models';
import { ModalCssClassEnum } from '@core/enums';
import { SingleproductComponent } from '../../features/home/components/singleproduct/singleproduct.component';

@Injectable({ providedIn: 'root' })
export class ImageViewerService {
  constructor(private modalCtrl: ModalController) {}

  async openSingleProduct(article: MenuItem) {
    const isLongMode =
      (article?.gruposModificadores?.length || 0) > 0 || (article?.productosCanal?.[0]?.precios?.length || 0) > 1;
    const cssClass = isLongMode
      ? ModalCssClassEnum.CommonLong
      : ModalCssClassEnum.CommonMedium;

    const modal = await this.modalCtrl.create({
      component: SingleproductComponent,
      componentProps: { article },
      cssClass: cssClass,
      backdropDismiss: false,
    });
    await modal.present();
    return modal.onDidDismiss();
  }
}
